import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/demos/otivio-frictionless-onboarding")({
    beforeLoad: () => {
        throw redirect({ to: "/design/features/otivio-frictionless-onboarding", replace: true });
    },
});
